import React, { useContext } from 'react';
import store from '../../store';
import { auth } from '../../constants';
// Custom Components
import ModalFooter from '../ModalFooter';
// Material components
import {
    Dialog,
    DialogContent,
    DialogTitle
} from '@material-ui/core';

export default function SendEmailVerification() {
    const { reducers, modals, state } = useContext(store);

    const handleOpen = () => {
        reducers.handleModals('sendVerificationEmail', modals.sendVerificationEmail ? false : true)
    };

    const handleSubmit = () => {
        var user = auth.currentUser;
        if (user !== null) {
            user.sendEmailVerification()
                .then(() => handleOpen())
                .catch((error) => window.alert(error.message));
        }
    }

    return (
        <Dialog open={modals.sendVerificationEmail} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Send Verification Email</DialogTitle>
            <DialogContent>
                {state.user.emailVerfied
                    ? `If you have not received a verification email from 5 words story, click
                        "Confirm".`
                    : `Your email address has already been verified.`}
            </DialogContent>
            <DialogContent>

            </DialogContent>
            <ModalFooter
                handleSubmit={handleSubmit}
                handleOpen={handleOpen} />
        </Dialog>
    );
}